import React from "react";
import BrowseView from "./Views/BrowseView";
import { observer } from "mobx-react-lite";

const BrowsePresenter = observer(({ model }) => {
  
  const handleQueryChange = (newQuery) => model.setQuery(newQuery);
  const handleSearch = () => model.searchArtworks();
  const handleLoadNextPage = () => model.loadNextPage();
  const handleAddToFavorites = (item) => model.addToFavorites(item, "painting");
  const isFavorite = (item) => model.isFavorite(item, "painting");
  return (
    <>
      
      <BrowseView
        query={model.getQuery()} 
        setQuery={handleQueryChange} 
        onSearch={handleSearch} 
        results={model.searchResults} 
        totalCount={model.totalCount} 
        loading={model.loading} 
        hasNextPage={model.hasNextPage} 
        onLoadNextPage={handleLoadNextPage} 
        onAddToFavorites={handleAddToFavorites} 
        isFavorite={isFavorite}
      />
    </>
  );
});

export default BrowsePresenter;